// material-ui
import { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
// import Box from '@mui/material/Box';

// project import
import Localization from './Localization';
import Search from './Search';
import ThemeSwitch from './ThemeSwitch';
// import Message from './Message';
import Profile from './Profile';
// import Notification from './Notification';
// import FullScreen from './FullScreen';
// import MobileSection from './MobileSection';

import useConfig from 'hooks/useConfig';
import { MenuOrientation } from 'config';
import DrawerHeader from 'layout/Dashboard/Drawer/DrawerHeader';

import { useMemo } from 'react';
import WCProfile from './wcProfile';
import { getDomainName } from 'utils/commonFunctions';
// ==============================|| HEADER - CONTENT ||============================== //

const domain = getDomainName();

export default function HeaderContent() {
  const { menuOrientation, i18n } = useConfig();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const localization = useMemo(() => <Localization />, [i18n]);

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
  const isIONetgate = domain === 'io-netgate.net' ? true :false;

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {<Search />}
      {/* {downLG && <Box sx={{ width: '100%', ml: 1 }} />} */}
      {localization}

      {/* <Notification />
      <Message /> */}
      <ThemeSwitch />
      {!isIONetgate && <WCProfile />}
      {/* {!downLG && <FullScreen />} */}
      {/* !downLG &&  <Profile /> */}
      {/* {downLG && <MobileSection />} */}
    </>
  );
}
